import React from 'react';
import './order-dashboard-skeleton.scss';

const OrderDashboardSkeleton = () => (
  <div className='od-skeleton-page' aria-busy='true' aria-label='Loading dashboard'>
    <div className='od-skeleton-card'>
      <aside className='od-skeleton-sidebar'>
        <div className='od-skeleton-block od-skeleton-block--title' />
        <div className='od-skeleton-block od-skeleton-block--line' />
        <div className='od-skeleton-block od-skeleton-block--line od-skeleton-block--short' />
        <div className='od-skeleton-nav'>
          {[1, 2, 3].map((n) => (
            <div key={n} className='od-skeleton-nav-row'>
              <div className='od-skeleton-dot' />
              <div className='od-skeleton-block od-skeleton-block--nav' />
            </div>
          ))}
        </div>
      </aside>

      <main className='od-skeleton-main'>
        <div className='od-skeleton-block od-skeleton-block--tag' />
        <div className='od-skeleton-block od-skeleton-block--heading' />
        <div className='od-skeleton-block od-skeleton-block--line' />
        <div className='od-skeleton-block od-skeleton-block--line od-skeleton-block--medium' />
        <div className='od-skeleton-content'>
          <div className='od-skeleton-block od-skeleton-block--field' />
          <div className='od-skeleton-block od-skeleton-block--field' />
        </div>
        <div className='od-skeleton-actions'>
          <div className='od-skeleton-block od-skeleton-block--btn' />
        </div>
      </main>
    </div>
  </div>
);

export default OrderDashboardSkeleton;
